import React from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  const scrollToCTA = (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.getElementById('money-cta');
    if (el) el.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <section className="min-h-[65vh] md:min-h-screen flex flex-col items-center justify-center px-4 md:px-6 relative pt-12 md:pt-20 pb-12 md:pb-20 overflow-hidden" data-id="element-127">
      <div className="max-w-4xl mx-auto text-center relative z-10 w-full" data-id="element-128">
        <FadeIn delay={100} data-id="element-129">
          <h1 className="font-serif text-[2.4rem] md:text-6xl lg:text-8xl font-bold text-navy mb-3 md:mb-5 leading-[1.1]" data-id="element-130">
            Who Programmed{' '}
            <span className="italic font-normal" data-id="element-131">You to Spend?</span>
          </h1>
        </FadeIn>

        <FadeIn delay={400} data-id="element-132">
          <div className="bg-navy/5 border border-navy/10 rounded-xl px-4 py-3 md:px-6 md:py-4 max-w-md md:max-w-lg mx-auto mb-6 md:mb-10" data-id="element-133">
            <p className="text-sm md:text-base text-charcoal/80 font-light leading-snug" data-id="element-134">
              The Hidden Psychology Behind Your Money Habits
            </p>
            <p className="text-[10px] md:text-xs text-gold font-semibold tracking-wider uppercase mt-1.5" data-id="element-135">
              And the System That Helps You Take Back Control
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={800} data-id="element-136">
          <div className="relative w-full max-w-[220px] md:max-w-lg mx-auto mb-4 md:mb-7" data-id="element-137">
            <div className="absolute inset-0 bg-gold/20 blur-2xl md:blur-3xl rounded-full transform translate-y-4 md:translate-y-8" data-id="element-138"></div>
            <img src="https://cdn.magicpatterns.com/uploads/kGVLSUQm3HPCmdkSXZAaKT/Final_Mockup.png" alt="Who Programmed You to Spend? Ebook on Tablet" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-139" />
          </div>
          <a href="#money-cta" onClick={scrollToCTA} className="inline-block bg-gold text-navy font-semibold text-sm md:text-lg px-7 md:px-10 py-3 md:py-4 rounded-full transition-transform duration-300 hover:scale-105 hover:shadow-xl hover:shadow-gold/20" data-id="element-140">
            Break The Cycle
          </a>
          <p className="mt-2 text-charcoal/70 text-xs md:text-sm font-medium tracking-wide" data-id="element-141">
            Instant digital download • Read on any device
          </p>
        </FadeIn>
      </div>

      <FadeIn delay={1200} className="absolute bottom-4 md:bottom-10 left-1/2 -translate-x-1/2" data-id="element-142">
        <div className="animate-bounce-slow text-navy/40" data-id="element-143">
          <ChevronDown size={22} strokeWidth={1.5} data-id="element-144" />
        </div>
      </FadeIn>
    </section>;
}